import {isTechnicalGroup} from '@nursio-link/common/authorization';

import {graphqlClient} from '@/services/graphqlClient';
import type {User} from '@/services/graphqlHooks';
import {useGetMyUserInfoQuery} from '@/services/graphqlHooks';

import {useAuthUser, useGroups} from './useAuth';

export const useMyUser = () => {
  const groups = useGroups() || [];

  const skipUserDataCheck = groups.length && isTechnicalGroup(groups);

  const {data: myUser} = useGetMyUserInfoQuery(graphqlClient, undefined, {
    staleTime: Infinity,
    retry: false,
    enabled: !skipUserDataCheck,
  });

  const {data: authUser, isLoading: authUserIsLoading} = useAuthUser();

  if (authUserIsLoading) {
    return;
  }

  const name = myUser?.getMyUserInfo?.name;

  const myUserNamesExists = name?.firstName && name?.lastName;

  const fullName = myUserNamesExists
    ? `${name.firstName} ${name.lastName}`
    : authUser?.username;

  const firstName = name?.firstName || authUser?.username;
  const initials = myUserNamesExists
    ? `${name.firstName.charAt(0)}${name.lastName.charAt(0)}`
    : `${authUser?.username.slice(0, 2)}`;

  return {
    userInfo: myUser?.getMyUserInfo as User,
    fullName,
    firstName,
    initials,
  };
};
